import React from 'react';
import styled from 'styled-components';
import Switch3D2DToolbar from '../mapToggle';
import ToolbarContainer from '../ToolbarContainer';
import useViewerStore from '../../../store-zustand/viewer';
import TooltipIconButton from "components/TooltipIconButton";
import { AddRounded, RemoveRounded } from '@mui/icons-material';
import { animationZoom } from '../../../components/MapView/MapUtils';

const Wrapper = styled(ToolbarContainer)`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`;

const ZoomToolbar = () => {
  const { viewer } = useViewerStore();

  return (
    <Wrapper data-tour="step-7">
      <ToolbarContainer className="zoom">
        <Switch3D2DToolbar />
        <TooltipIconButton title="Zoom in" ariaLabel="zoom-in" placement="top" onClick={(e) => {animationZoom(viewer, 0.5);}} size={50}>
          <AddRounded />
        </TooltipIconButton>
        <TooltipIconButton title="Zoom out" ariaLabel="zoom-out" placement="top" onClick={(e) => {animationZoom(viewer, 2);}} size={50}>
          <RemoveRounded />
        </TooltipIconButton>        
      </ToolbarContainer>
    </Wrapper>
  );
}

export default ZoomToolbar;